/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import Card from '@mui/material/Card';
import { InputText } from "primereact/inputtext";
import { Button } from '@mui/material';
import axios from 'axios';
import { useCookies } from 'react-cookie';
import { Hidden } from "@material-ui/core";
import { useNavigate, useParams } from 'react-router-dom';
import LoadingComponent from '../../lib/LoadingComponent';
import { useDispatch, useSelector } from 'react-redux'
import {
  getBizName, getLogo, setLogo, getStyle, setBizID, setStyle, setBusinessName, setAuthen, setRoles, setServices
} from '../../libs/todoSlice'
import Cookie from '../../lib/Cookie';
import fontColor from '../../lib/fontColor';
import { getEmailRedux, setEmailRedux, getLoadingRedux, setLoadingRedux, getShowRedux, setShowRedux } from '../../libs/sendMailSlice'
import { logoutSession } from '../../lib/logoutRedirect';

function SendMail() {
  // console.log(sent)
  const dispatch = useDispatch()
  const businessName = useSelector(getBizName)
  const logo = useSelector(getLogo)
  const style = useSelector(getStyle)
  // const [ email, setEmail ] = useState('')
  // const [ loading, setLoading ] = useState(false)
  // const [ show, setShow ] = useState(false)
  const [cookie, setCookie, removeCookie] = useCookies(['new_user', 'account', 'cookie_consent_accepting'])
  const navigate = useNavigate()
  const params = useParams()

  const email = useSelector(getEmailRedux)
  const setEmail = (action) => {
    dispatch(setEmailRedux({
      email: action
    }))
  }

  const loading = useSelector(getLoadingRedux)
  const setLoading = (action) => {
    dispatch(setLoadingRedux({
      loading: action
    }))
  }

  const show = useSelector(getShowRedux)
  const setShow = (action) => {
    dispatch(setShowRedux({
      show: action
    }))
  }

  useEffect(() => {
    setShow(false)
    recheck()
    setEmail(JSON.parse(localStorage.getItem('account')).email ? JSON.parse(localStorage.getItem('account')).email.filter(email => email.pivot.primary_flg === 'Y').map(email => email.email).join('') : '')
    getPrefixDetail()
  }, [])

  const getPrefixDetail = async () => {
    await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/prefix?prefix=${params.prefix}`,
    }).then(({ data, status }) => {
      if (!data.data) {
        navigate('/notfound')
      } else {
        dispatch(setBizID({
          biz_id: data.data.businessID
        }))
        dispatch(setStyle({
          style: data.data.themes.style
        }))
        dispatch(setServices({
          services: data.data.services
        }))
      }
      getLogoApi(data.data.businessID)
      dispatch(setBusinessName({
        business_name: data.data.businessName
      }))
    }, ({ response }) => {
    })
  }
  const getLogoApi = async (bizid) => {
    await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/logo?business_id=${bizid}`,
    }).then(({ data, status }) => {
      dispatch(setLogo({
        logo: data.data
      }))
    }, ({ response }) => {

    })
  }
  const resendEmail = async () => {
    setLoading(true)
    await axios({
      method: 'POST',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/loalevel`,
    }).then(() => {
      navigate(`/${params.prefix}/login-user/send-mail/success?email=${email}`)
      // sent()
    }, ({ response }) => {
      const { status } = response
      if (status === 401) {
        navigate(`/${params.prefix}`)
      }
    })
    setLoading(false)
  }
  const recheck = async () => {
    await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/loalevel`,
    }).then(({ data }) => {
      // if(cookie.cookie_consent_accepting){
      setCookie('new_user', {
        ...cookie.new_user,
        confirmed_email: data.data.confirmed,
      }, {
        path: '/',
        expires: new Date(Date.now() + 3600000),
        // httpOnly: true
      })
      if (data.data.confirmed) {
        navigate(`/${params.prefix}/login-user/verify-success`)
      }
      setShow(true)
      // }
    }, ({ response }) => {
      const { status } = response
      if (status === 401) {
        navigate(`/${params.prefix}`)
      }
      setShow(true)
    })
  }
  const logout = async () => {
    await logoutSession({
      removeCookie,
      dispatch,
      oauth: cookie.oauth,
      prefix: params.prefix,
    })
  };

  return show && (
    <div
      style={{
        background: '#F8F9FA',
        height: '100vh',
      }}
    >
      <div style={{ padding: '30px 80px 0 80px' }}>
        <img src={`data:image/png;base64, ${logo}`} alt=""
          onError={({ target }) => {
            target.src = '/one-platform.png'
          }}
          style={{
            maxHeight: '60px',
            maxWidth: '60px',
          }} />
        <span
          style={{
            fontWeight: '600',
            color: '#000',
            padding: '10px',
          }}
        >{businessName}</span>
        <span
          style={{
            float: 'right',
          }}
        >
          <Button
            onClick={() => {
              logout()
            }}
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
              padding: '9px 15px',
              gap: '10px',
              width: '120px',
              height: '36px',
              borderRadius: '6px',
              float: 'right',
              color: fontColor(style.secondary_color),
              background: style.secondary_color,
            }}
          >
            ออกจากระบบ
          </Button>
        </span>
      </div>
      <Hidden xsDown>
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <img
            src="/img_create_path.png"
            style={{
              position: 'fixed',
              width: '670.75px',
              height: '650.54px',
              top: '110px',
            }}
            alt=''
          />
        </div>
      </Hidden>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '60px 40px',
          gap: '36px',
        }}
      >
        <div style={{ zIndex: '1' }}>
          <Card
            style={{
              width: '467px',
              background: 'rgba(0, 0, 0, 0.2)',
              borderRadius: '32px',
              padding: '60px 40px',
              color: '#053075'
            }}
          >
            <div>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <img
                  src="/icon_user_login-user.png"
                  style={{
                    width: '48px',
                    height: '48px'
                  }}
                  alt=''
                />
              </div>
              <div>
                <span
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    fontWeight: '700',
                    fontSize: '18px',
                    lineHeight: '50px',
                    letterSpacing: '0.02em',
                  }}>ยืนยันตัวตนผ่านอีเมล</span>
              </div>
              <div style={{ paddingTop: '10px' }}>
                <div style={{ display: 'flex', paddingBottom: '5px' }}>
                  <label htmlFor="email">อีเมลที่ใช้ในการการยืนยันตัวตน</label>
                </div>
                <InputText
                  placeholder="กรอกอีเมลที่ใช้ในการเข้าสู่ระบบ"
                  value={email}
                  style={{
                    background: '#FFFFFF',
                    border: '1px solid #EEEEEE',
                    borderRadius: '6px',
                    width: '387px',
                    height: '36px',
                  }}
                  disabled
                  onChange={({ target }) => {
                    setEmail(target.value);
                  }}
                />
              </div>
              <div style={{ marginTop: '20px' }}>
                {loading ? <LoadingComponent /> :
                  <Button
                    sx={{
                      width: '387px',
                      height: '36px',
                      borderRadius: '6px',
                      textTransform: 'none',
                      color: fontColor(style.secondary_color),
                      background: style.secondary_color,
                    }}
                    onClick={() => {
                      resendEmail()
                    }}
                    disabled={email.length === 0}
                  >
                    Send mail
                  </Button>
                }
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default SendMail